
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBkgak7yL-d8MHlA6SzUMkJpoUWsl1Gf-k",
  authDomain: "veyra-200d7.firebaseapp.com",
  projectId: "veyra-200d7",
  storageBucket: "veyra-200d7.firebasestorage.app",
  messagingSenderId: "490542093361",
  appId: "1:490542093361:web:a3ab23ae68d40a1c863110",
  measurementId: "G-MK5WR0QZQ9",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

/* Firestore lives in ./firebaseDb and is imported only by the two pages that
   read it (Product, Pricing). Initialising it here put the whole SDK --
   most of a 103 KB (gzipped) chunk -- on every page load, including the
   homepage, which never touches it.

   Analytics starts once the page has finished loading and the browser is
   idle. Started up front, it fetched 155 KB of Google Tag Manager script plus
   two Firebase set-up calls in the middle of the first load, competing with
   the hero image for bandwidth and the main thread. Nothing in the app reads
   the analytics instance, so it only has to run, not run first. */
if (typeof window !== "undefined") {
  const start = () => {
    import("firebase/analytics")
      .then(({ getAnalytics, isSupported }) => isSupported().then((ok) => ok && getAnalytics(app)))
      .catch(() => {});
  };
  const whenIdle = () => {
    if ("requestIdleCallback" in window) window.requestIdleCallback(start, { timeout: 5000 });
    else setTimeout(start, 2500);
  };
  if (document.readyState === "complete") whenIdle();
  else window.addEventListener("load", whenIdle, { once: true });
}

export default app;
